<template>
  <div>
 
    <section  class="navbarsection" style="margin-top: -50px;">
          <div class="txtdata">
            <h1  style="padding-top: 200px;"></h1>
          </div>
            <div class="videosection" >
              <div  v-show="pvisvideo === true && pvpictureimage === false ">
                <Transition class="transition thing">
                  <video-background 
                    playbackRate=0.2
                    :src="src"
                    :poster="poster"
                    :class="`thing playercss`"
                    :style="`height: 600px;`">
                  </video-background>
                </Transition>
              </div>
            
                <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
                </div>
      
                <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
                v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
       
          </div>
          <div class="overlay"></div>
          <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
            <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
          </div>
        </section>

<section>
  <div class="seven3css" >
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-9">
        <div class="formattoptext"><b>{{pyeardesc}} </b> <b>GOALS</b></div>
        <div class="accordion" id="accordionExample" style="background-color: grey;">
          <div class="accordion-item"  v-for="(cat, index) in getgoalperf" :key="cat.gcid">
            <h2 class="accordion-header" :id="`heading${cat.gcid}`">
              <button  @click="onClick(catid=cat.gcid)" class="accordion-button" :id="`accbtn${index%2}`" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse${cat.gcid}`" aria-expanded="false" :aria-controls="`collapse${cat.gcid}`">
                {{cat.gcatdesc}}
              </button>
            </h2>
            <div :id="`collapse${cat.gcid}`" class="accordion-collapse collapse" :aria-labelledby="`heading${cat.gcid}`" data-bs-parent="#accordionExample">
              <div class="accordion-body" style="background-color: whitesmoke;">
                
                <table class="table" style="background-color: whitesmoke;">
                  <tr v-for="(goal, index) in allgoalslisting" :key="goal.gid">
                    <td >
                      <div class="row">
                          <div class="col-sm-12 col-sm-12 col-md-6">
                            <div v-html="goal.goaldetails"></div>
                          </div>
                          <div class="col-sm-12 col-sm-12 col-md-6 formatrightdiv">
                            <div v-for="gmap in getmappings">
                              <div v-if="gmap.Year===pyear">
                                <div v-if="goal.gid===gmap.All_goals" style="float: left;">
                                <div v-for="sdg in getsdgs" :key="sdg.sdgsid">
                                    <div v-if="gmap.Sdgs===sdg.sdgsid">
                                      <img :src="`${myPicUrl}${sdg.sdgsimage}`" class="sdgimage"/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-3">
        <span v-html="susthighlight" class=" card shadow"  style="padding: 20px;"></span>
      </div>
    </div>
  </div>
</section>

<section style="padding-bottom: 200px;">
  <div class="seven3css" style="max-width: 90%; margin: 0 auto; margin-top: 100px;">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-9">
        <div class="formattoptext"><b>{{pyeardesc}} </b> <b>GOALS AND PERFORNACE</b></div>
        <div class="accordion" id="accordionExample1">
          <div class="accordion-item"  v-for="(cat, index) in getgoalperf" :key="cat.gcid">
            <h2 class="accordion-header" :id="`heading1${cat.gcid}`">
              <button  @click="onClick1(catid=cat.gcid)" class="accordion-button" :id="`accbtn${index%2}`" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse1${cat.gcid}`" aria-expanded="false" :aria-controls="`collapse1${cat.gcid}`">
                {{cat.gcatdesc}}
              </button>
            </h2>
            <div :id="`collapse1${cat.gcid}`" class="accordion-collapse collapse" :aria-labelledby="`heading1${cat.gcid}`" data-bs-parent="#accordionExample1">
              <div class="accordion-body">
                <table class="table">
                  <tr v-for="(goal, index) in allgoalslisting" :key="goal.gid">
                    <td>
                      <div class="row">
                          <div class="col-sm-12 col-sm-12 col-md-6">
                            <div v-html="goal.goaldetails"></div>
                          </div>
                          <div class="col-sm-12 col-sm-12 col-md-6 formatrightdiv">
                            <div v-if="goal.gpefachieved===false">
                              <i class="fa-solid fa-xmark" style="color:red; font-size: 40px;"></i>
                            </div>
                            <div v-else>
                              <i class="fa-solid fa-check" style="color: green; font-size: 40px;"></i>
                            </div>
                          </div>
                        </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-3">
      </div>
    </div>
  </div>
</section>


<!-- <div class="allreports">
  <AllReports :lastrecordsreportpresent="lastrecordsreportpresent" :reportpresentation="reportpresentation" 
  :openpdf="openpdf" :singlereporttitle="singlereporttitle" :rptfulltext="rptfulltext" 
  :rpcoverpageimagepath="rpcoverpageimagepath" :rplinkname="rplinkname" :bgimage="bgimage" 
  :showbg="showbg"  :showrptfulltext="showrpttext"  />
</div> -->

  </div>
</template>

<script>
import AllReports from '@/components/AllReports.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
require('@/globalDeclare.js');
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
  AllReports
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  // pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,


 

  getgoalperf: '',
  allgoalslisting: [],
  getmappings: [],
  catid: 0,
  pyear: '',
  pyeardesc: '',
  getsdgs: [],

  susthighlight: '',

  reportpresentation: [],
  lastrecordsreportpresent: [],
  bgimage: '',

  showrpttext: false,
  showbg: false,


  getclickedId: '',
  myPicUrl: '',
  }
},
methods: {
  async onClick(catid) {
    let catidone = catid
  //------------all sliders(generic)---------------
  await axios.get(`getallgoalslistings/${catidone}`).then(
    response => {
        this.allgoalslisting = response.data

        axios.get('getsdgcmappings/goalsandperformance').then(
          response => {
              this.getmappings = response.data
              console.log(this.getmappings)
        })
        .catch((error) => {
            console.log(error)
          })
  })
  .catch((error) => {
      console.log(error)
    })
},
async onClick1(catid) {
    let catidone = catid
  //------------all sliders(generic)---------------
  await axios.get(`getallgoalslistings/${catidone}`).then(
    response => {
        this.allgoalslisting = response.data

        axios.get('getsdgcmappings/goalsandperformance').then(
          response => {
              this.getmappings = response.data
              console.log(this.getmappings)
        })
        .catch((error) => {
            console.log(error)
          })
  })
  .catch((error) => {
      console.log(error)
    })
}
},
async mounted() {
  this.myPicUrl = myUrlPath
await axios.get('allpagespv/goalsandperformance').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      this.pvpictureimage = this.videoimage.pvpictureimage

       if (this.pvisvideo === true) {
          this.src = this.videoimage.pvsrc
        }
        else {
            const config = {
            autoLoad: true,
            scenchange: true,
            compass: false,
            northOffset: -20.5,
            default: {
                firstScene: "hotspotoffice",
                sceneFadeDuration: 1000,
                autoRotate: -.7,
                setTimeout: 100,
                preview: this.poster
                
            },
            scenes: {
                hotspotoffice: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 0,
                    type: "equirectangular",
                    panorama: this.pvpanorama1,
                },
                anotherhotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 0,
                      type: "equirectangular",
                      panorama: this.pvpanorama2,
                  },
                  lasthotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 0,
                      type: "equirectangular",
                      panorama: this.pvpanorama3,
                  },
                
              }
          };
          pannellum.viewer('panorama', config);
        }
      })
      .catch((error) => {
          console.log(error)
        })
   //------------corpgovernance info---------------
   await axios.get('getsustainabilityoverview/').then(
    response => {
        this.sustsec1text = response.data[0].sustsec1text
        // this.cpimg = response.data.cpimg
  })
  .catch((error) => {
      console.log(error)
    })

  //------------all highlights---------------
  await axios.get('getallhiglights/goalsandperformance').then(
    response => {
        this.susthighlight = response.data[0].highlightdesc
  })
  .catch((error) => {
      console.log(error)
    })

  //------------Get Reports---------------
  await axios.get('reportpresentationlisting/goalsandperformance').then(
    response => {
      this.reportpresentation = response.data
      var reportcnt = parseInt(response.data[0].rpid)       

      axios.get(`reportpresentationsinglelisting/${reportcnt}`).then(
      response => {
        this.lastrecordsreportpresent = response.data
        this.rppdfpath = response.data.rppdfpath
        this.rptitle = response.data.rptitle
        this.rpdate = response.data.rpdate
        this.rplinkname = response.data.rplinkname
        this.rptfulltext = response.data.rptfulltext
        this.rpcoverpageimagepath = response.data.rpcoverpageimagepath
        this.singlereporttitle = response.data.singlereporttitle
        this.rplinkname = response.data.rplinkname
        this.rpdate = response.data.rpdate
        this.bgimage = response.data.bgimage
        this.showrpttext = response.data.showrptfulltext
        this.showbg = response.data.showbgimage
      })
      .catch((error) => {
        console.log(error)
      })
            
    })
  .catch((error) => {
    console.log(error)
  })
  

  //------------all sliders(generic)---------------
  await axios.get('getbgimage/goalsandperformance').then(
    response => {
        this.bgimage = response.data[0].bgimageupload
  })
  .catch((error) => {
      console.log(error)
    })

  //------------all sliders(generic)---------------
  await axios.get('getallgoalscategory/').then(
    response => {
        this.getgoalperf = response.data
  })
  .catch((error) => {
      console.log(error)
    })

  //------------YEARS---------------
  await axios.get('getyears/').then(
    response => {
        this.pyear = response.data[0].yearid
        this.pyeardesc = response.data[0].yeardesc
  })
  .catch((error) => {
      console.log(error)
    })

  //------------SDGS---------------
   await axios.get('getsdgslistings/').then(
    response => {
        this.getsdgs = response.data
        console.log(this.getsdgs)
  })
  .catch((error) => {
      console.log(error)
    })

}
}
</script>

<style scoped>
.section03 {
  height: 300px;
}
.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}

.seven3css {
 max-width: 90%; 
 margin: 0 auto; 
 margin-top: 200px;
}

.reportpresentcss {
  margin-top: 300px;
}

#accordionFlushExample {
  padding-left: 100px;
  width: 90%;
}
.sdgimage {
  width: 114px;
  height: 114px;
  border-radius: 8px;
  padding: 2px;
  margin: 0 auto;
}
table, td, th {
  border: 1px solid;
}
table {
  width: 100%;
  border-collapse: collapse;
  background-color: whitesmoke;
}
.formattoptext {
  padding: 20px; 
  border-top: thin solid orangered; 
  font-size: 30px;
}
.formatrightdiv {
  border-left: solid thin; 
  text-align: center;
}
#accbtn0 {
  background-color:whitesmoke;
}
#accbtn1 {
  background-color:rgb(236, 234, 236);
}
/* Move the background and make it larger. 
/* Media Query CSS*/
.tdcolor0 {
  background-color:rgb(236, 234, 236);
}
.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;

}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {

 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {

 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {

 }


 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {

 }


 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {

 } 

/* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1400px) {

  }
  
  @media only screen and (min-width: 1600px) {

  } 
</style>
